module.exports = __webpack_public_path__ + "img/st.87a80269.png";